import ClassNames from "classnames";
import { FunctionComponent, ReactNode } from "react";
import styles from "../stylesheets/components/typography.module.css";
import ModuleWithHeadings from "./ModuleWithHeadings.js";

interface Props {
  id: string;
  title: string | undefined;
  subtitle: string | undefined;
  colors: { background?: string; color?: string } | undefined;
  className?: string;
  children: ReactNode;
}

const Typography: FunctionComponent<Props> = ({
  id,
  colors,
  title,
  subtitle,
  className,
  children,
}) => {
  return (
    <ModuleWithHeadings
      title={title}
      subtitle={subtitle}
      id={id}
      colors={colors}
      className={ClassNames(className, styles.Typography)}
    >
      {children}
    </ModuleWithHeadings>
  );
};

export default Typography;
